import { Typography } from '@stardust-ds/react';
import Select from '../../atoms/Select';
import styles from './index.module.scss';
import RcmpFormErrorMessage from '../../atoms/FormErrorMessage';
import intl from "react-intl-universal"
import { useContext, useEffect, useState } from 'react';
import RcmpTextArea from '../../atoms/TextArea';
import Input from '../../atoms/Input';
import RcmpSelectUsers from '../../molecules/SelectUsers';
import { PatternFormat } from "react-number-format"
import AuthContext from '../../../contexts/Auth';

function RcmpFirstStepNotificationAutomation(props) {
    const { getValues, setValue, aEventOptions, oBlocksOptions, fnSetBIsDisabledButton, errors, cTriggerSelected, fnSetCTriggerSelected, fnGenerateTextEvent, fnSetOBlocksOptions, bIsEditAutomation, bActiveAutomation } = props
   
    const [nDeadLineDaysValue, fnSetDeadLineDaysValue] = useState(!getValues("days") ? 0 : getValues("days"))
    const aBlocksOptions = [{ label: intl.get("modal_new_automation.whatever_block"), value: null }, ...oBlocksOptions]
    function fnHandleSelect(e, field) {
        if (!e) {
            setValue(field, undefined)
            setValue("blockId", undefined)
            setValue("fromBlockId", undefined)
            setValue("blockEvent", undefined)

            field === "triggerType" && fnSetCTriggerSelected("")
            fnSetBIsDisabledButton(true)
            if (field === "blockEvent") {
                setValue("blockId", undefined)
            }
            if (field === "blockMoved" || field === "fromBlockId") {
                setValue("blockId", undefined)
            }
            return
        }
        if (e.value === "activity_moved" && field === "triggerType") {
            const nBLockId = getValues("blockId")
            setValue("fromBlockId", nBLockId)
            setValue("blockEvent", undefined)
            setValue(field, e)
            fnSetCTriggerSelected(e.value)
            return
        }
        fnSetBIsDisabledButton(false)
        setValue(field, e)
        field === "triggerType" && fnSetCTriggerSelected(e.value)
        if (field === "blockEvent") {
            setValue("blockId", e)
        }

    }

    function fnOnChangeDeadLineDaysValue(e) {
        if (e.target.value === "" || Number(e.target.value) === (0 - 1)) {
            setValue("days", undefined)
            fnSetDeadLineDaysValue("")
            return
        }
        if (Number(e.target.value) < 0) {
            return
        }
        if (Number(e.target.value) <= 999) {
            setValue("days", Number(e.target.value))
            fnSetDeadLineDaysValue(Number(e.target.value))
            return
        }
        return
    }
    function fnHandleKeyPress(e) {
        const regex = /^\d+$/

        if (!regex.test(e.key)) {
            e.preventDefault()
        }
    }
    return (
        <>
            <div>

                {getValues("automationType") && <div className={styles.headerDescription} style={{ marginBottom: "32px" }}>
                    <Typography type="l2" color="#415364">{intl.get("modal_new_automation.create_notification")}</Typography>
                    {cTriggerSelected && <p>{fnGenerateTextEvent()}...</p>}
                </div>}

                <div className={styles.triggerArea}>
                    <Select onSelect={(e) => fnHandleSelect(e, "triggerType")} options={aEventOptions} label={`${intl.get("modal_new_automation.when_a")} *`} defaultValue={getValues("triggerType") || ""}  disabled={bIsEditAutomation || bActiveAutomation}/>
                    {["notification_expires_ago", "notification_expires_in"].includes(cTriggerSelected) && <div className={styles.numberField}>
                        <input type="number" className={styles.numberField} onChange={fnOnChangeDeadLineDaysValue} value={nDeadLineDaysValue} min="0" onKeyPress={fnHandleKeyPress} max={"999"} />
                        <Typography type="l3" color="#415364">{intl.get("modal_new_automation.days")}</Typography>
                    </div>}
                </div>
                {errors.triggerType && <RcmpFormErrorMessage>{errors.triggerType?.label?.message}</RcmpFormErrorMessage>}
            </div >
            <div>
                <Select onSelect={(e) => fnHandleSelect(e, getValues("triggerType")?.value !== "activity_moved" ? "blockEvent" : "fromBlockId")} options={cTriggerSelected !== "activity_moved" || getValues("blockEvent")?.value === null ? aBlocksOptions.slice(1) : aBlocksOptions} label={cTriggerSelected === "activity_moved" ? intl.get("modal_new_automation.from_block") : `${intl.get("modal_new_automation.in_block")} *`} defaultValue={cTriggerSelected !== "activity_moved" ? getValues("blockEvent") || "" : getValues("fromBlockId") || ""} />

                {errors?.blockEvent && <RcmpFormErrorMessage>{errors.blockEvent?.message}</RcmpFormErrorMessage>}
                {errors?.fromBlockId && <RcmpFormErrorMessage>{errors.fromBlockId?.message}</RcmpFormErrorMessage>}
            </div>
            {cTriggerSelected === "activity_moved" && <div>
                <Select onSelect={(e) => fnHandleSelect(e, "blockEvent")} options={cTriggerSelected !== "activity_moved" || getValues("fromBlockId")?.value === null ? aBlocksOptions.slice(1) : aBlocksOptions} label={intl.get("modal_new_automation.to_block")} defaultValue={getValues("blockEvent") || ""} />
                {errors?.blockEvent && <RcmpFormErrorMessage>{errors.blockEvent?.message}</RcmpFormErrorMessage>}
            </div>}
        </>
    )
}

function RcmpSecondStepNotificationAutomation(props) {
    const { register, setValue, errors, cTriggerSelected, getValues } = props
    const [cMessage, fnSetCMessage] = useState("")
    const [cEmailExterPerson, fnSetCEmailExterPerson] = useState(getValues("userExternEmail") || "")
    const oNotificationsOptions = [
        {
            label: intl.get("modal_new_automation.notification_params.internal"),
            value: "internal"
        },
        {
            label: intl.get("modal_new_automation.notification_params.external"),
            value: "external"
        },
    ]

    const [aNotificationSelected, fnSetANotificationSelected] = useState(oNotificationsOptions[0])
    function fnHandleSelect(e) {
        if (!e) {
            fnSetANotificationSelected(undefined)
            return
        }
        fnSetANotificationSelected(e)
        setValue("userTypeNotification", e)
    }

    function fnHandleSelectUser(e) {

        setValue("userNotificade", e)
    }

    function fnGenerateTextEvent() {
        switch (cTriggerSelected) {
            case "notification_expires_in":
                if (getValues("days") === 0) {
                    return intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today")
                }
                return intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_activity") + " " + getValues("days") + " " + intl.get("modal_new_automation.days")

            case "notification_expires_ago":
                if (getValues("days") === 0) {
                    return intl.get("modal_new_automation.activity") +intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today")
                }
                return intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expirated_since") + " " + getValues("days") + " " + intl.get("modal_new_automation.days")
            case "activity_created":
                return intl.get("modal_new_automation.notification_params.activity_created_manual")
            case "activity_moved":
                return intl.get("modal_new_automation.notification_params.activity_moved")
                    +
                    (getValues("fromBlockId") !== undefined ? getValues("fromBlockId")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.from_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.from_block") + getValues("fromBlockId")?.label : "")
                    +
                    (getValues("blockEvent") !== undefined ? getValues("blockEvent")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.to_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.to_block") + getValues("blockEvent")?.label : "")
            case "activity_finished":
                return intl.get("modal_new_automation.notification_params.activity_finished")
            case "activity_deleted":
                return intl.get("modal_new_automation.notification_params.activity_deleted")
            default:
                return ""
        }
    }
    function fnPhoneInput(customProps) {
        return (
            <Input
                isFullWidth
                placeholder={intl.get("type")}
                label={intl.get("modal_new_automation.notification_params.phone")}
                {...customProps}
                {...register("userExterPhone")}
            />
        )
    }
    function fnGetUserEmail(e) {
        setValue("userExternEmail", e.target.value)
        fnSetCEmailExterPerson(e.target.value)
    }
    return (
        <>
            <div className={styles.headerDescriptionData} style={{ margin: "0px" }}>
                <Typography type="l2" color="#415364">{intl.get("modal_new_automation.create_notification")}</Typography>
                <p style={{ marginTop: "-2px" }}>{fnGenerateTextEvent()}</p>

                {cTriggerSelected !== "activity_moved" && <p style={{ marginTop: "-2px" }}>{intl.get("modal_new_automation.event_params_info.deadline_activity.in_the_block")}</p>}
                {cTriggerSelected !== "activity_moved" && <p style={{ marginTop: "-2px" }}>{getValues("blockEvent")?.label}</p>}

            </div>
            <div className={styles.automationMessageContainer}>
                <RcmpTextArea placeholder={intl.get("type")} label={intl.get("modal_new_automation.notification_params.notification_mesage")} {...register("notificationMessage", {
                    validate: value => value.trim() !== '' || intl.get("cant_fill_with_space")
                })} />
                {errors.notificationMessage && <RcmpFormErrorMessage>{errors.notificationMessage?.message}</RcmpFormErrorMessage>}
            </div>
            <Select onSelect={fnHandleSelect} options={oNotificationsOptions} label={intl.get("modal_new_automation.notification_params.who_notificate")} defaultValue={getValues("userTypeNotification") || oNotificationsOptions[0]} />
            {aNotificationSelected?.value === "internal" && <RcmpSelectUsers multiSelect isFullWidth searchable label={intl.get("modal_new_automation.notification_params.user_notificade")} placeholder={intl.get("select")} onSelect={fnHandleSelectUser} defaultValue={getValues("userNotificade")} />}
            {aNotificationSelected?.value === "external" &&
                <div className={styles.externUser}>
                    <Input
                        isFullWidth
                        {...register("userExternName", {
                            validate: value => value.trim() !== '' || intl.get("cant_fill_with_space")
                        })}
                        placeholder={intl.get("type")}
                        label={intl.get("modal_new_automation.notification_params.name") + "*"}
                    />
                    <div className={styles.emailContainer}>
                        {errors.userExternName && <RcmpFormErrorMessage>{errors.userExternName?.message}</RcmpFormErrorMessage>}
                    </div>
                    <Input isFullWidth type={"email"} placeholder={intl.get("type")} label={intl.get("modal_new_automation.notification_params.email")} onChange={(e) => fnGetUserEmail(e)} value={cEmailExterPerson} />
                    {/* <PatternFormat format="+55 (##) #.####-####" customInput={fnPhoneInput} /> */}
                    <div className={styles.emailContainer}>
                        {errors.userExternEmail && <RcmpFormErrorMessage className={styles.emailError}>{errors.userExternEmail?.message}</RcmpFormErrorMessage>}
                    </div>

                </div>

            }
        </>
    )
}

function RcmpThirdStepNotificationAutomation(props) {
    const { getValues, setValue, cTriggerSelected, nStep } = props
    const aUsers = getValues("userNotificade")
    const [cEventMessage, fnSetCEventMessage] = useState("")
    const { oUser } = useContext(AuthContext)
    let cUsersNotify = aUsers?.length > 0 ? aUsers?.map(user => { return user.label }).join(", ") : oUser.data.user_cname

    useEffect(() => {
        if (!getValues("userNotificade")?.length && getValues("userTypeNotification").value === "internal")
            setValue("userNotificade", [{ label: oUser.data.user_cname, value: oUser.data.user_nid }])
    }, [])

    useEffect(() => {
        switch (getValues("triggerType").value) {
            case "notification_expires_in":
                if (getValues("days") === 0) {
                    return fnSetCEventMessage(intl.get("modal_new_automation.event_params_info.deadline_activity.pendding_activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
                }
                return fnSetCEventMessage(intl.get("modal_new_automation.event_params_info.deadline_activity.pendding_activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_activity") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))

            case "notification_expires_ago":
                if (getValues("days") === 0) {
                    return fnSetCEventMessage(intl.get("modal_new_automation.event_params_info.deadline_activity.pendding_activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
                }
                return fnSetCEventMessage(intl.get("modal_new_automation.event_params_info.deadline_activity.pendding_activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expirated_since") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))

            case "activity_created":
                return fnSetCEventMessage(intl.get("modal_new_automation.notification_params.activity_created_manual"))
            case "activity_finished":
                return fnSetCEventMessage(intl.get("modal_new_automation.notification_params.activity_finished"))
            case "activity_deleted":
                return fnSetCEventMessage(intl.get("modal_new_automation.notification_params.activity_deleted"))
            default:
                return
        }
    }, [nStep])

    function fnGenereteTextActivityMoved() {
        const cText = intl.get("modal_new_automation.notification_params.activity_moved")
            +
            (getValues("fromBlockId") !== undefined ? getValues("fromBlockId")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.from_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.from_block") + getValues("fromBlockId")?.label : "")
            +
            (getValues("blockEvent") !== undefined ? getValues("blockEvent")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.to_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.to_block") + getValues("blockEvent")?.label : "")
        return <span className={styles.dataRender}>{cText}</span>
    }
    return (
        <div className={styles.checkoutContainer}>

            <div className={styles.textInfoReview}>
                <div className={styles.checkoutTextContainer}>
                    <p className={styles.firstLineContainer}>
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.notification_params.notification_review.notify_user")}</Typography>
                        <span className={styles.dataRender}>{getValues("userTypeNotification").value === "internal" ? cUsersNotify : getValues("userExternName")}</span>
                        {getValues("userTypeNotification").value === "external" && (<Typography type="l2" color="#415364">{intl.get("modal_new_automation.notification_params.notification_review.in_email")}</Typography>)}
                        {getValues("userTypeNotification").value === "external" && (<span className={styles.dataRender}>{getValues("userExternEmail")}</span>)}
                        {/* <Typography type="l2" color="#415364">{intl.get("modal_new_automation.notification_params.notification_review.with_mensagem").toLowerCase()}</Typography> */}
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.notification_params.notification_review.when_a").toLowerCase()}</Typography>


                        {cTriggerSelected !== "activity_moved" && <Typography type="l2" color="#415364">{cEventMessage}</Typography>}
                        {cTriggerSelected === "activity_moved" && fnGenereteTextActivityMoved()}
                        {cTriggerSelected !== "activity_moved" && <span className={styles.dataRender}> {intl.get("modal_new_automation.event_params_info.deadline_activity.in_the_block")}</span>}
                        {cTriggerSelected !== "activity_moved" && <span className={styles.dataRender}>{getValues("blockEvent").label}</span>}
                    </p>
                    <p className={styles.secondLineContainerNotification}>
                        <p>{intl.get("modal_new_automation.notification_params.notification_review.notification_text")}</p>
                        <Typography type="l2" color="#415364">{getValues("notificationMessage")}</Typography>
                    </p>
                </div>
            </div>
        </div>



    )
}
export default function RcmpAutomationNotification(props) {

    const { setValue, errors, getValues, watch, aBlocks, fnSetBIsDisabledButton, nStep, bIsEditAutomation, bActiveAutomation } = props;
    const aEventOptions = [
        { value: "activity_created", label: intl.get("modal_new_automation.event_param.activity_created") },
        { value: "activity_moved", label: intl.get("modal_new_automation.event_param.activity_moved") },
        { value: "activity_finished", label: intl.get("modal_new_automation.event_param.activity_finished") },
        { value: "activity_deleted", label: intl.get("modal_new_automation.event_param.activity_deleted") },
        { value: "notification_expires_ago", label: intl.get("modal_new_automation.event_param.activity_expires_ago") },
        { value: "notification_expires_in", label: intl.get("modal_new_automation.event_param.activity_expires_in") },
    ]
    const [oBlocksOptions, fnSetOBlocksOptions] = useState([])
    const [bAllFilled, fnSetBAllFilled] = useState(true)
    const [cTriggerSelected, fnSetCTriggerSelected] = useState(getValues("triggerType")?.value || "")

    function fnGenerateTextEvent() {
        switch (cTriggerSelected) {
            case "notification_expires_in":
                return intl.get("modal_new_automation.create_notification_params.activity_expires_in")
            case "notification_expires_ago":
                return intl.get("modal_new_automation.create_notification_params.activity_expires_ago")
            case "activity_created":
                return intl.get("modal_new_automation.notification_params.activity_created_manual")
            case "activity_moved":
                return intl.get("modal_new_automation.notification_params.activity_moved")
            case "activity_finished":
                return intl.get("modal_new_automation.notification_params.activity_finished")
            case "activity_deleted":
                return intl.get("modal_new_automation.notification_params.activity_deleted")
            default:
                return ""
        }
    }
    useEffect(() => {
        const oBlockOptions = aBlocks?.map((block) => ({
            label: block.opbl_cname,
            value: block.opbl_nid,
        }))

        fnSetOBlocksOptions(oBlockOptions)
    }, [aBlocks])
    useEffect(() => {
        if (nStep !== 0 && (!getValues("triggerType") || !getValues("blockEvent") || getValues("days") === undefined) || (cTriggerSelected === "activity_moved" && (!getValues("fromBlockId") || getValues("blockEvent") === undefined))) {
            fnSetBIsDisabledButton(true)
            return
        }
        if (nStep !== 0 && cTriggerSelected === "activity_moved" && getValues("triggerType") && (getValues("fromBlockId") || getValues("blockEvent"))) {
            fnSetBIsDisabledButton(false)
            return
        }

        fnSetBIsDisabledButton(false)
        return

    }, [watch("triggerType"), watch("blockEvent"), watch("days"), watch("fromBlockId"), watch("blockEvent"), nStep])
    return (
        <div className={styles.eventTriggerContainer}>
            {nStep === 1 && <RcmpFirstStepNotificationAutomation oBlocksOptions={oBlocksOptions} fnSetOBlocksOptions={fnSetOBlocksOptions} bAllFilled={bAllFilled} fnSetBAllFilled={fnSetBAllFilled} aEventOptions={aEventOptions} fnSetCTriggerSelected={fnSetCTriggerSelected} cTriggerSelected={cTriggerSelected} fnGenerateTextEvent={fnGenerateTextEvent} {...props} bIsEditAutomation={bIsEditAutomation} bActiveAutomation={bActiveAutomation}/>}
            {nStep === 2 && <RcmpSecondStepNotificationAutomation oBlocksOptions={oBlocksOptions} bAllFilled={bAllFilled} fnSetBAllFilled={fnSetBAllFilled} aEventOptions={aEventOptions} fnSetCTriggerSelected={fnSetCTriggerSelected} cTriggerSelected={cTriggerSelected} fnGenerateTextEvent={fnGenerateTextEvent} getValues={getValues} {...props} />}
            {nStep === 3 && <RcmpThirdStepNotificationAutomation oBlocksOptions={oBlocksOptions} bAllFilled={bAllFilled} fnSetBAllFilled={fnSetBAllFilled} aEventOptions={aEventOptions} fnSetCTriggerSelected={fnSetCTriggerSelected} cTriggerSelected={cTriggerSelected} fnGenerateTextEvent={fnGenerateTextEvent} getValues={getValues} {...props} />}
        </div>
    )
}